package com.heelion.farmafreelance

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.viewmodel.compose.viewModel
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import farmafreelance.composeapp.generated.resources.Res
import farmafreelance.composeapp.generated.resources.*
import farmafreelance.composeapp.generated.resources.farmafreelance_logo
import androidx.compose.runtime.key
import com.heelion.farmafreelance.ui.BackHandler
import com.heelion.farmafreelance.ui.LocalAppLocale
import com.heelion.farmafreelance.ui.AppEnvironment
import com.heelion.farmafreelance.models.AnnuncioTurno
import com.heelion.farmafreelance.models.Farmacia
import com.heelion.farmafreelance.models.Farmacista
import com.heelion.farmafreelance.models.Infermiere
import com.heelion.farmafreelance.models.LoginRequest
import com.heelion.farmafreelance.models.UserRole
import com.heelion.farmafreelance.models.etichetta
import com.heelion.farmafreelance.models.isProfessionista
import com.heelion.farmafreelance.models.professione
import com.heelion.farmafreelance.models.Professionista
import com.heelion.farmafreelance.ui.AppIcons
import com.heelion.farmafreelance.ui.AuthViewModel
import com.heelion.farmafreelance.ui.DisponibilitaScreen
import com.heelion.farmafreelance.ui.FarmaciaScreen
import com.heelion.farmafreelance.ui.FarmacistaScreen
import com.heelion.farmafreelance.ui.HomeScreen
import com.heelion.farmafreelance.ui.ForgotPasswordDialog
import com.heelion.farmafreelance.ui.CodiceLoginDialog
import com.heelion.farmafreelance.ui.SelettoreProfessione
import com.heelion.farmafreelance.ui.TextAssistantFab
import com.heelion.farmafreelance.voice.VoiceIntent
import com.heelion.farmafreelance.ui.LoginScreen
import com.heelion.farmafreelance.ui.PreferitiScreen
import com.heelion.farmafreelance.ui.ProfileDetailScreen
import com.heelion.farmafreelance.ui.ProfileScreen
import com.heelion.farmafreelance.ui.RegisterScreen
import androidx.compose.material3.Badge
import androidx.compose.material3.BadgedBox
import com.heelion.farmafreelance.ui.NotificationScreen
import com.heelion.farmafreelance.ui.SupportoScreen
import com.heelion.farmafreelance.ui.SettingsScreen
import com.heelion.farmafreelance.ui.TutorialScreen
import com.heelion.farmafreelance.ui.StoricoScreen
import com.heelion.farmafreelance.ui.GuadagniScreen
import com.heelion.farmafreelance.ui.PagamentiScreen
import com.heelion.farmafreelance.ui.AgendaScreen
import com.heelion.farmafreelance.ui.toCreatoreTipo
import com.heelion.farmafreelance.ui.LocalAssistente
import com.heelion.farmafreelance.ui.rememberSuonoNotifiche
import com.heelion.farmafreelance.ui.rememberLampeggio
import com.heelion.farmafreelance.ui.BersaglioTour
import com.heelion.farmafreelance.ui.TourFarmy
import com.heelion.farmafreelance.ui.tourBersaglio
import androidx.compose.ui.graphics.graphicsLayer
import com.heelion.farmafreelance.ui.rememberAssistente
import com.heelion.farmafreelance.push.rememberPushNotifiche
import com.heelion.farmafreelance.push.rememberPromemoriaLocali
import com.heelion.farmafreelance.agent.PianificatorePromemoria
import kotlinx.datetime.Clock

// Definizione Colori "FarmaFreelance Theme"
val FarmaFreelanceMedicalGreen = Color(0xFF00A388)
val FarmaFreelanceTeal = Color(0xFF4DB6AC)

val FarmaFreelanceLightBlue = Color(0xFF47C1FF)
/** Blu scuro del logo e della mascotte Farmy (campionato da drawable/farmyno00.png). */
val FarmaFreelanceBlue = Color(0xFF0B3BC1)
val FarmaFreelanceWhite = Color(0xFFFFFFFF)

private val LightColorScheme = lightColorScheme(
    primary = FarmaFreelanceMedicalGreen,
    secondary = FarmaFreelanceTeal,
    tertiary = Color(0xFF81D4FA),
    background = FarmaFreelanceWhite,
    surface = FarmaFreelanceWhite,
    onPrimary = FarmaFreelanceWhite,
    onSecondary = FarmaFreelanceWhite,
    onTertiary = Color.Black,
    onBackground = Color.Black,
    onSurface = Color.Black,
)

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun App(
    onOpenCalendar: (AnnuncioTurno) -> Unit = {},
    onExit: () -> Unit = {},
    platformContext: Any? = null
) {
    val authViewModel: AuthViewModel = viewModel { AuthViewModel() }

    // Inizializza lo storage per la persistenza locale subito
    LaunchedEffect(platformContext) {
        authViewModel.initStorage(platformContext)
    }

    val currentLanguage = authViewModel.selectedLanguage

    // Stati di navigazione sollevati sopra AppEnvironment per persistere al cambio lingua
    var selectedTab by remember { mutableStateOf(0) }
    // Intento vocale/testuale riconosciuto in una sezione ma da eseguire in un'altra (es. "vai
    // alla ricerca", o un CercaFarmacie detto dalla Home): questa sezione decide solo DOVE
    // mandare l'utente, la sezione di destinazione decide COME eseguirlo, con la sua stessa
    // logica di sempre.
    var pendingVoiceIntent by remember { mutableStateOf<VoiceIntent?>(null) }

    fun sezioneToTab(sezione: VoiceIntent.Sezione): Int = when (sezione) {
        VoiceIntent.Sezione.HOME -> 0
        VoiceIntent.Sezione.DISPONIBILITA -> 1
        VoiceIntent.Sezione.RICERCA -> 2
        else -> 3 // PROFILO (le pagine sopra le tab non cambiano tab, vedi apriPagina)
    }

    // Pagine aperte sopra le tab: anche Farmy può aprirle tutte ("apri le impostazioni").
    var showGuadagni by remember { mutableStateOf(false) }
    var showPagamenti by remember { mutableStateOf(false) }
    var showAgenda by remember { mutableStateOf(false) }
    var showPreferiti by remember { mutableStateOf(false) }
    var showSupporto by remember { mutableStateOf(false) }
    var showSettings by remember { mutableStateOf(false) }
    var showNotifications by remember { mutableStateOf(false) }
    var showTutorial by remember { mutableStateOf(false) }
    // Tour guidato di Farmy: parte da solo solo per i nuovi iscritti (al primo accesso), poi dal "?".
    var tourAttivo by remember { mutableStateOf(false) }
    fun avviaTour() {
        showTutorial = false
        showNotifications = false
        selectedTab = 0
        tourAttivo = true
    }
    LaunchedEffect(authViewModel.deveVedereTour) {
        if (authViewModel.deveVedereTour) avviaTour()
    }
    LaunchedEffect(authViewModel.currentUserRole) {
        if (authViewModel.currentUserRole == null) tourAttivo = false
    }
    var showStorico by remember { mutableStateOf(false) }

    /**
     * Apre una pagina sopra le tab chiudendo le altre; chiudendola si torna alla tab di prima.
     * Nessun intento lasciato in sospeso: altrimenti una sezione lo rieseguirebbe più tardi
     * riaprendo la pagina da sola.
     */
    fun apriPagina(sezione: VoiceIntent.Sezione) {
        showGuadagni = false; showPreferiti = false; showSupporto = false; showSettings = false
        showNotifications = false; showTutorial = false; showStorico = false; showAgenda = false; showPagamenti = false
        when (sezione) {
            // Solo per i professionisti; una farmacia resta sul Profilo.
            VoiceIntent.Sezione.GUADAGNI ->
                if (authViewModel.isProfessionista) showGuadagni = true else selectedTab = 3
            VoiceIntent.Sezione.STORICO -> showStorico = true
            VoiceIntent.Sezione.AGENDA -> showAgenda = true
            VoiceIntent.Sezione.PREFERITI -> showPreferiti = true
            VoiceIntent.Sezione.NOTIFICHE -> showNotifications = true
            VoiceIntent.Sezione.IMPOSTAZIONI -> showSettings = true
            VoiceIntent.Sezione.SUPPORTO -> showSupporto = true
            VoiceIntent.Sezione.TUTORIAL -> showTutorial = true
            else -> selectedTab = sezioneToTab(sezione)
        }
        println("--- [ROUTER] Pagina aperta: $sezione ---")
    }

    val onVoiceIntentRouted: (VoiceIntent) -> Unit = { intent ->
        if (intent is VoiceIntent.NavigaA && intent.sezione.pagina) {
            apriPagina(intent.sezione)
        } else {
            pendingVoiceIntent = intent
            val nuovoTab = when (intent) {
                is VoiceIntent.NavigaA -> sezioneToTab(intent.sezione)
                is VoiceIntent.CreaTurno, is VoiceIntent.GestisciAnnunci, is VoiceIntent.Conferma -> 1
                is VoiceIntent.FiltraTurniStato -> 0
                else -> 2 // CercaFarmacie, CercaFarmacisti, MostraTurniFarmacia, ApriMappa
            }
            println("--- [ROUTER] Intento: $intent -> tab $nuovoTab (era $selectedTab) ---")
            selectedTab = nuovoTab
        }
    }
    var showRegister by remember { mutableStateOf(false) }
    var showForgotPassword by remember { mutableStateOf(false) }
    var emailPerReset by remember { mutableStateOf("") }
    var showExitDialog by remember { mutableStateOf(false) }

    var detailFarmacista by remember { mutableStateOf<Farmacista?>(null) }
    var detailFarmacia by remember { mutableStateOf<Farmacia?>(null) }
    var detailInfermiere by remember { mutableStateOf<Infermiere?>(null) }

    /** Apre la scheda di un profilo (farmacia, farmacista o infermiere) dal suo id. */
    fun apriProfiloDi(id: String, ruolo: UserRole) = when (ruolo) {
        UserRole.FARMACISTA -> authViewModel.getFarmacistaById(id) { detailFarmacista = it }
        UserRole.INFERMIERE -> authViewModel.getInfermiereById(id) { detailInfermiere = it }
        else -> authViewModel.getFarmaciaById(id) { detailFarmacia = it }
    }

    // Gestione tasto Back (Android/KMP)
    BackHandler(enabled = true) {
        when {
            showSettings -> showSettings = false
            showNotifications -> showNotifications = false
            showTutorial -> showTutorial = false
            showStorico -> showStorico = false
            showAgenda -> showAgenda = false
            showPagamenti -> showPagamenti = false
            showGuadagni -> showGuadagni = false
            showPreferiti -> showPreferiti = false
            showSupporto -> showSupporto = false
            detailFarmacista != null || detailFarmacia != null || detailInfermiere != null -> {
                detailFarmacista = null
                detailFarmacia = null
                detailInfermiere = null
            }
            showRegister -> showRegister = false
            selectedTab != 0 -> selectedTab = 0
            else -> showExitDialog = true
        }
    }

    // L'AI di FarmaFreelance (modello addestrato + regole), condivisa da assistente testuale e microfoni.
    val assistente = rememberAssistente(authViewModel, apriProfilo = { professionista, farmacia ->
        detailFarmacista = professionista as? Farmacista
        detailInfermiere = professionista as? Infermiere
        detailFarmacia = farmacia
    })

    // Promemoria programmati da Farmy sul telefono secondo quelli attivati dall'utente (turni della
    // giornata, turno imminente, da confermare, in attesa), aggiornati a ogni cambio di turni o preferenze. Al logout si cancellano; prima del login non
    // si toccano, così le sveglie già programmate restano anche se l'app è aperta e non loggata.
    val promemoriaLocali = rememberPromemoriaLocali()
    var eraLoggato by remember { mutableStateOf(false) }
    LaunchedEffect(
        authViewModel.currentUserRole, authViewModel.currentMatches, authViewModel.confirmedShiftsDetails,
        authViewModel.preferenzePromemoria, promemoriaLocali
    ) {
        val locali = promemoriaLocali ?: return@LaunchedEffect
        val ruolo = authViewModel.currentUserRole
        if (ruolo == null) {
            if (eraLoggato) locali.programma(emptyList())
            eraLoggato = false
            return@LaunchedEffect
        }
        eraLoggato = true
        locali.programma(
            PianificatorePromemoria.calcola(
                ruolo, authViewModel.currentMatches,
                authViewModel.confirmedShiftsDetails.mapNotNull { a -> a.id?.let { it to a } }.toMap(),
                Clock.System.now(),
                preferenze = authViewModel.preferenzePromemoria
            )
        )
    }

    // Notifiche push (promemoria turni, proposte, conferme anche ad app chiusa): si attivano
    // a ogni accesso, così il server ha sempre il token aggiornato di questo dispositivo.
    // Suono delle notifiche: entrando nell'app una volta se ci sono notifiche non lette o proposte a
    // cui rispondere (da accettare o da confermare, come il numero sulla Home), e poi ogni volta che
    // arriva una notifica nuova. Con l'app aperta le notifiche si ricontrollano ogni 30 secondi.
    val suonoNotifiche = rememberSuonoNotifiche()
    var suonoIngressoFatto by remember { mutableStateOf(false) }
    var notificheGiaViste by remember { mutableStateOf<Set<String>?>(null) } // null = primo caricamento da fare
    LaunchedEffect(authViewModel.currentUserRole, authViewModel.notifications, authViewModel.currentMatches) {
        val ruolo = authViewModel.currentUserRole?.toCreatoreTipo()
        if (ruolo == null) {
            suonoIngressoFatto = false
            notificheGiaViste = null
            return@LaunchedEffect
        }
        val attuali = authViewModel.notifications.mapNotNull { it.id }.toSet()
        val viste = notificheGiaViste
        // Il primo elenco vuoto può essere solo "non ancora caricato": si aspetta quello vero.
        if (viste != null || attuali.isNotEmpty()) notificheGiaViste = (viste ?: emptySet()) + attuali
        val nuovaArrivata = viste != null && authViewModel.notifications.any { !it.isRead && it.id !in viste }

        val daRispondere = authViewModel.currentMatches.count { m ->
            (m.stato == com.heelion.farmafreelance.models.MatchStato.PROPOSTO && m.propostoDa != ruolo) ||
                (m.stato == com.heelion.farmafreelance.models.MatchStato.ACCETTATO && m.propostoDa == ruolo)
        }
        val nonLette = authViewModel.notifications.any { !it.isRead }
        val ingresso = !suonoIngressoFatto && (nonLette || daRispondere > 0)
        if (ingresso) suonoIngressoFatto = true
        if (ingresso || nuovaArrivata) {
            suonoNotifiche()
            // Insieme al suono lampeggia quello a cui fare attenzione.
            // La campanella anche per le proposte: sono nella sezione "Da gestire" delle notifiche.
            authViewModel.lampeggiaNotifiche = true
            if (ingresso && daRispondere > 0) authViewModel.lampeggiaProposte = true
        }
    }
    LaunchedEffect(authViewModel.lampeggiaNotifiche) {
        if (authViewModel.lampeggiaNotifiche) { kotlinx.coroutines.delay(6_000); authViewModel.lampeggiaNotifiche = false }
    }
    LaunchedEffect(authViewModel.lampeggiaProposte) {
        if (authViewModel.lampeggiaProposte) { kotlinx.coroutines.delay(6_000); authViewModel.lampeggiaProposte = false }
    }
    LaunchedEffect(authViewModel.currentUserRole) {
        while (authViewModel.currentUserRole != null) {
            kotlinx.coroutines.delay(30_000)
            authViewModel.aggiornaNotifiche()
        }
    }

    val push = rememberPushNotifiche()
    LaunchedEffect(authViewModel.currentUserRole, push) {
        if (authViewModel.currentUserRole != null && push != null) {
            push.attiva { token, piattaforma -> authViewModel.registraTokenPush(token, piattaforma) }
        }
    }

    AppEnvironment(currentLanguage) {
        CompositionLocalProvider(LocalAssistente provides assistente) {
        MaterialTheme(colorScheme = LightColorScheme) {
            val farmacisti = remember { mutableStateListOf<Farmacista>() }
            val farmacie = remember { mutableStateListOf<Farmacia>() }
            val annunci = remember { mutableStateListOf<AnnuncioTurno>() }


            if (showExitDialog) {
                androidx.compose.material3.AlertDialog(
                    onDismissRequest = { showExitDialog = false },
                    title = { Text(stringResource(Res.string.exit_app_title)) },
                    text = { Text(stringResource(Res.string.exit_app_confirm)) },
                    confirmButton = {
                        androidx.compose.material3.TextButton(onClick = onExit) {
                            Text(stringResource(Res.string.yes))
                        }
                    },
                    dismissButton = {
                        androidx.compose.material3.TextButton(onClick = { showExitDialog = false }) {
                            Text(stringResource(Res.string.no))
                        }
                    }
                )
            }

            Surface(modifier = Modifier.fillMaxSize(), color = Color.Transparent) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(
                            Brush.verticalGradient(
                                colors = listOf(Color(0xFFF8FAFC), Color(0xFFE4EFF7))
                            )
                        )
                ) {
                    if (showSettings) {
                    SettingsScreen(
                        onBack = { showSettings = false },
                        currentLanguage = currentLanguage,
                        onLanguageChange = { 
                            authViewModel.updateLanguage(it)
                        },
                        selectedColor = authViewModel.selectedThemeColor,
                        onColorChange = { authViewModel.updateThemeColor(it) },
                        viewModel = authViewModel
                    )
                } else if (showNotifications) {
                    NotificationScreen(
                        viewModel = authViewModel,
                        onBack = { showNotifications = false },
                        onIntent = { _, intent -> showNotifications = false; onVoiceIntentRouted(intent) }
                    )
                } else if (showTutorial) {
                    TutorialScreen(
                        onBack = { showTutorial = false },
                        onRivediTour = { avviaTour() }
                    )
                } else if (showGuadagni) {
                    GuadagniScreen(
                        viewModel = authViewModel,
                        onBack = { showGuadagni = false }
                    )
                } else if (showPagamenti) {
                    PagamentiScreen(
                        viewModel = authViewModel,
                        onBack = { showPagamenti = false }
                    )
                } else if (showAgenda) {
                    AgendaScreen(
                        viewModel = authViewModel,
                        onBack = { showAgenda = false }
                    )
                } else if (showStorico) {
                    StoricoScreen(
                        viewModel = authViewModel,
                        onBack = { showStorico = false }
                    )
                } else if (authViewModel.currentUserRole == null) {
                    if (showRegister || authViewModel.registrationSuccess) {
                        RegisterScreen(
                            viewModel = authViewModel,
                            onBackToLogin = { 
                                showRegister = false 
                                authViewModel.registrationSuccess = false
                            },
                            onSettingsClick = { showSettings = true },
                            currentLanguage = currentLanguage,
                            onLanguageChange = { authViewModel.updateLanguage(it) }
                        )
                    } else {
                        LoginScreen(
                            onLoginSuccess = { email, pass ->
                                authViewModel.login(LoginRequest(email, pass))
                            },
                            onRegisterClick = { showRegister = true },
                            onSettingsClick = { showSettings = true },
                            currentLanguage = currentLanguage,
                            onLanguageChange = { authViewModel.updateLanguage(it) },
                            isLoading = authViewModel.isLoading,
                            errorMessage = authViewModel.errorMessage,
                            rememberMe = authViewModel.rememberMe,
                            onRememberMeChange = { authViewModel.updateRememberMe(it) },
                            initialEmail = authViewModel.savedEmail,
                            onForgotPasswordClick = { emailPerReset = it; showForgotPassword = true }
                        )
                        if (authViewModel.tokenDueFattori != null) {
                            CodiceLoginDialog(authViewModel)
                        }
                        if (showForgotPassword) {
                            ForgotPasswordDialog(
                                viewModel = authViewModel,
                                initialEmail = emailPerReset,
                                onDismiss = { showForgotPassword = false }
                            )
                        }
                    }
                } else if (showPreferiti) {
                    PreferitiScreen(
                        viewModel = authViewModel,
                        onBack = { showPreferiti = false },
                        onViewProfile = { id, targetRole ->
                            apriProfiloDi(id, targetRole)
                            showPreferiti = false
                        }
                    )
                } else if (showSupporto) {
                    SupportoScreen(
                        viewModel = authViewModel,
                        onBack = { showSupporto = false }
                    )
                } else if (detailFarmacista != null || detailFarmacia != null || detailInfermiere != null) {
                    ProfileDetailScreen(
                        farmacista = detailFarmacista,
                        farmacia = detailFarmacia,
                        infermiere = detailInfermiere,
                        viewModel = authViewModel,
                        onBack = {
                            detailFarmacista = null
                            detailFarmacia = null
                            detailInfermiere = null
                        }
                    )
                } else {
                    val role = authViewModel.currentUserRole
                    Scaffold(
                        containerColor = Color.Transparent,
                        floatingActionButton = {
                            TextAssistantFab(
                                onIntent = { _, intent -> onVoiceIntentRouted(intent) },
                                nascondiSaluto = tourAttivo,
                                nomeUtente = {
                                    authViewModel.currentUserProfessionista?.nome
                                        ?: authViewModel.currentUserFarmacia?.nomeFarmacia
                                }
                            )
                        },
                        topBar = {
                            CenterAlignedTopAppBar(
                                // Due icone a sinistra (tutorial, notifiche) e due a destra (impostazioni,
                                // logout): così il logo resta esattamente al centro.
                                navigationIcon = {
                                    Row {
                                        IconButton(onClick = { showTutorial = true }) {
                                            Icon(
                                                imageVector = AppIcons.Support,
                                                contentDescription = "Tutorial",
                                                tint = MaterialTheme.colorScheme.primary
                                            )
                                        }
                                        val lampeggio = rememberLampeggio(authViewModel.lampeggiaNotifiche)
                                        IconButton(
                                            onClick = { showNotifications = true },
                                            modifier = Modifier.tourBersaglio(BersaglioTour.CAMPANELLA).graphicsLayer {
                                                scaleX = 1f + 0.3f * lampeggio
                                                scaleY = 1f + 0.3f * lampeggio
                                                // Oscilla come una campanella che suona (solo mentre lampeggia).
                                                rotationZ = if (authViewModel.lampeggiaNotifiche) 30f * (lampeggio - 0.5f) else 0f
                                            }
                                        ) {
                                            BadgedBox(
                                                badge = {
                                                    if (authViewModel.unreadNotificationsCount > 0) {
                                                        Badge { Text(authViewModel.unreadNotificationsCount.toString()) }
                                                    }
                                                }
                                            ) {
                                                Icon(
                                                    imageVector = AppIcons.Notifications,
                                                    contentDescription = "Notifications",
                                                    // Giallo Campanellina; lampeggiando passa all'arancione
                                                    tint = androidx.compose.ui.graphics.lerp(Color(0xFFFFD600), Color(0xFFFF6D00), lampeggio)
                                                )
                                            }
                                        }
                                    }
                                },
                                title = {
                                    Image(
                                        painter = painterResource(Res.drawable.farmafreelance_logo),
                                        contentDescription = "FarmaFreelance Logo",
                                        modifier = Modifier.height(60.dp) // Ingrandito da 40.dp a 60.dp
                                    )
                                },
                                actions = {
                                    IconButton(onClick = { showSettings = true }) {
                                        Icon(
                                            imageVector = AppIcons.Settings,
                                            contentDescription = "Settings",
                                            tint = Color.Gray // Ingranaggio Grigio
                                        )
                                    }
                                    IconButton(onClick = { authViewModel.logout() }) {
                                        Icon(
                                            imageVector = AppIcons.Logout, 
                                            contentDescription = "Logout", 
                                            tint = MaterialTheme.colorScheme.error
                                        )
                                    }
                                },
                                colors = TopAppBarDefaults.centerAlignedTopAppBarColors(
                                    containerColor = Color.Transparent
                                )
                            )
                        },
                        bottomBar = {
                            val role = authViewModel.currentUserRole
                            val newMatchesCount = authViewModel.currentMatches.count { match ->
                                val isProposer = match.propostoDa == role?.toCreatoreTipo()
                                match.stato == com.heelion.farmafreelance.models.MatchStato.PROPOSTO && !isProposer
                            }

                            Surface(
                                modifier = Modifier
                                    .padding(horizontal = 16.dp, vertical = 12.dp)
                                    .navigationBarsPadding(),
                                color = Color.Transparent
                            ) {
                                Card(
                                    modifier = Modifier.fillMaxWidth(),
                                    colors = CardDefaults.cardColors(
                                        containerColor = Color.White.copy(alpha = 0.8f) // Fisso Bianco Cristallino
                                    ),
                                    shape = RoundedCornerShape(20.dp),
                                    border = androidx.compose.foundation.BorderStroke(
                                        width = 0.5.dp,
                                        color = Color(0xFFC0C0C0).copy(alpha = 0.3f) // Ancora più tenue
                                    ),
                                    elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
                                ) {
                                    NavigationBar(
                                        containerColor = Color.Transparent,
                                        tonalElevation = 0.dp,
                                        modifier = Modifier.height(72.dp)
                                    ) {
                                        val navColors = androidx.compose.material3.NavigationBarItemDefaults.colors(
                                            indicatorColor = Color(0xFFE1F5FE), // Celeste / Blu Chiaro
                                            selectedIconColor = MaterialTheme.colorScheme.primary,
                                            unselectedIconColor = Color.Gray
                                        )

                                        NavigationBarItem(
                                            selected = selectedTab == 0,
                                            onClick = { selectedTab = 0 },
                                            label = { Text(stringResource(Res.string.tab_home), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = {
                                                BadgedBox(
                                                    badge = {
                                                        if (newMatchesCount > 0) {
                                                            Badge { Text(newMatchesCount.toString()) }
                                                        }
                                                    }
                                                ) {
                                                    Icon(AppIcons.Home, contentDescription = "Home")
                                                }
                                            }
                                        )

                                        NavigationBarItem(
                                            modifier = Modifier.tourBersaglio(BersaglioTour.ANNUNCI),
                                            selected = selectedTab == 1,
                                            onClick = { selectedTab = 1 },
                                            label = { Text(stringResource(Res.string.tab_ads), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.List, contentDescription = "Annunci") }
                                        )

                                        NavigationBarItem(
                                            modifier = Modifier.tourBersaglio(BersaglioTour.CERCA),
                                            selected = selectedTab == 2,
                                            onClick = { selectedTab = 2 },
                                            label = { Text(stringResource(Res.string.tab_search), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.Search, contentDescription = "Ricerca") }
                                        )
                                        
                                        NavigationBarItem(
                                            modifier = Modifier.tourBersaglio(BersaglioTour.PROFILO),
                                            selected = selectedTab == 3,
                                            onClick = { selectedTab = 3 },
                                            label = { Text(stringResource(Res.string.tab_profile), fontSize = 10.sp) },
                                            colors = navColors,
                                            icon = { Icon(AppIcons.Account, contentDescription = "Profilo") }
                                        )
                                    }
                                }
                            }
                        }
                    ) { padding ->
                        Column(modifier = Modifier.fillMaxSize().padding(padding)) {
                            // Farmacia che lavora anche con gli infermieri: due spazi separati
                            // (Home, turni pubblicati e ricerca seguono la scelta).
                            if (role == UserRole.FARMACIA && authViewModel.infermieriAttivi && selectedTab in 0..2) {
                                SelettoreProfessione(authViewModel, Modifier.padding(horizontal = 16.dp, vertical = 6.dp))
                            }
                            when (selectedTab) {
                                0 -> {
                                    val userName = if (role?.isProfessionista == true)
                                        authViewModel.currentUserProfessionista?.nome ?: role.professione?.etichetta.orEmpty()
                                    else
                                        authViewModel.currentUserFarmacia?.nomeFarmacia ?: "Farmacia"
                                        
                                    HomeScreen(
                                        role = role,
                                        userName = userName,
                                        viewModel = authViewModel,
                                        onOpenCalendar = onOpenCalendar,
                                        onViewProfile = { id, targetRole -> apriProfiloDi(id, targetRole) },
                                        onVoiceIntentRouted = onVoiceIntentRouted,
                                        pendingIntent = pendingVoiceIntent,
                                        onPendingIntentConsumed = { pendingVoiceIntent = null }
                                    )
                                }
                                1 -> DisponibilitaScreen(
                                    viewModel = authViewModel,
                                    pendingIntent = pendingVoiceIntent,
                                    onPendingIntentConsumed = { pendingVoiceIntent = null },
                                    onVoiceIntentRouted = onVoiceIntentRouted
                                )
                                2 -> {
                                    // Il professionista cerca farmacie, la farmacia cerca professionisti.
                                    if (role?.isProfessionista == true) {
                                        FarmaciaScreen(
                                            viewModel = authViewModel,
                                            pendingIntent = pendingVoiceIntent,
                                            onPendingIntentConsumed = { pendingVoiceIntent = null },
                                            onVoiceIntentRouted = onVoiceIntentRouted
                                        )
                                    } else {
                                        FarmacistaScreen(
                                            viewModel = authViewModel,
                                            pendingIntent = pendingVoiceIntent,
                                            onPendingIntentConsumed = { pendingVoiceIntent = null },
                                            onVoiceIntentRouted = onVoiceIntentRouted
                                        )
                                    }
                                }
                                3 -> ProfileScreen(
                                        viewModel = authViewModel,
                                        currentLanguage = currentLanguage,
                                        onLanguageChange = { authViewModel.updateLanguage(it) },
                                        onLogout = { authViewModel.logout() },
                                        onNavigateToPreferiti = { showPreferiti = true },
                                        onNavigateToSupporto = { showSupporto = true },
                                        onNavigateToStorico = { showStorico = true },
                                        onNavigateToGuadagni = { showGuadagni = true },
                                        onNavigateToPagamenti = { showPagamenti = true },
                                        onNavigateToAgenda = { showAgenda = true }
                                    )
                            }
                        }
                    }
                }

                // Tour di Farmy sopra a tutto (solo nella schermata principale, con utente dentro).
                if (tourAttivo && authViewModel.currentUserRole != null) {
                    TourFarmy(
                        ruolo = authViewModel.currentUserRole,
                        nome = authViewModel.currentUserProfessionista?.nome ?: authViewModel.currentUserFarmacia?.nomeFarmacia
                    ) {
                        tourAttivo = false
                        if (authViewModel.deveVedereTour) authViewModel.segnaTourVisto()
                    }
                }
            }
        }
        }
    }
}
}
